import React from 'react';
import { filterControlClassName } from '../../config/constants';

const FilterSelect = ({
  name,
  value,
  onChange,
  options = [],
  placeholder = 'Select...',
  className = '',
  getOptionValue = (opt) => opt.value ?? opt.id,
  getOptionLabel = (opt) => opt.label ?? opt.name,
}) => (
  <select
    name={name}
    value={value || ''}
    onChange={(e) => onChange(e.target.value)}
    className={`${filterControlClassName} ${!value ? 'text-gray-500' : ''} ${className}`}
  >
    <option value="" className="text-gray-500">
      {placeholder}
    </option>
    {options.map((opt) => {
      const optionValue = getOptionValue(opt);
      return (
        <option key={optionValue} value={optionValue}>
          {getOptionLabel(opt)}
        </option>
      );
    })}
  </select>
);

export default FilterSelect;
